import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareChecklist: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSquareChecklist"><Path d="M7.54297 9.49775L8.66797 10.2478L10.5396 7.75224M13.808 9H16.308M13.75 15H16.25M7.54297 15.4989L8.66797 16.2489L10.5396 13.7534M7 20.5H17.5C19.1569 20.5 20.5 19.1569 20.5 17.5V7C20.5 5.34315 19.1569 4 17.5 4H7C5.34315 4 4 5.34315 4 7V17.5C4 19.1569 5.34315 20.5 7 20.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSquareChecklist;
